export const API_DOCS_URL = process.env.NEXT_PUBLIC_API_DOCS_URL;
export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL;
